var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4043 0.5C14.321 0.5 15.0713 1.25033 15.0713 2.16699V10.5L10.0713 15.5H1.73828C0.821615 15.5 0.0712891 14.7497 0.0712891 13.833V2.16699C0.0712891 1.25033 0.821615 0.5 1.73828 0.5H13.4043ZM1.73828 13.833H9.23828V9.66699H13.4043V2.16699H1.73828V13.833ZM11.0713 5.00879L6.35449 9.72461L3.4043 6.77539L4.58008 5.59961L6.34668 7.36621L9.87988 3.83301L11.0713 5.00879Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdded);
export default __webpack_public_path__ + "static/media/note-added.d514e98de5168efe89459a80bffd1e3a.svg";
export { ForwardRef as ReactComponent };